import { render, staticRenderFns } from "./CustomerDetail.vue?vue&type=template&id=0ca229fa&"
import script from "./CustomerDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerDetail.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDetail.vue?vue&type=style&index=0&id=0ca229fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports